import { Link } from "react-router-dom";

/**
 * The redesign's underline tabs (guide §3): a nav with a subtle bottom border; each link is 500-weight muted
 * text with a 2 px transparent bottom border; the current one is `--color-text` on an accent border with
 * `aria-current="page"`. Counts render in Geist Mono.
 */
export type UnderlineTab = {
  key: string;
  label: string;
  href: string;
  count?: number;
};

export function UnderlineTabs({
  label,
  tabs,
  currentKey,
  className,
}: {
  /** Accessible name for the nav (a `review.*` key, once step 6 adds it). */
  label: string;
  tabs: readonly UnderlineTab[];
  currentKey: string;
  /** Extra class for variants (the practice tab bar has its own metrics). */
  className?: string;
}): JSX.Element {
  return (
    <nav className={className === undefined ? "tabs" : `tabs ${className}`} aria-label={label}>
      {tabs.map((tab) => (
        <Link
          key={tab.key}
          to={tab.href}
          className="tabs__tab"
          aria-current={tab.key === currentKey ? "page" : undefined}
        >
          {tab.label}
          {tab.count === undefined ? null : <span className="tabs__count">{`(${tab.count})`}</span>}
        </Link>
      ))}
    </nav>
  );
}
